import { Component, xml } from "@odoo/owl";

/**
 * Találati lista komponens
 */
class RecordList extends Component {
    static template = xml`
        <div class="record-list">
            <table t-if="props.records and props.records.length > 0" class="decisions-list table">
                <thead>
                    <tr>
                        <th t-foreach="getTableColumns()" t-as="column" t-key="column.field" t-esc="column.label"/>
                        <th>Műveletek</th>
                    </tr>
                </thead>
                <tbody>
                    <tr t-foreach="props.records" t-as="record" t-key="record.id" t-att-data-id="record.id">
                        <td t-foreach="getTableColumns()" t-as="column" t-key="column.field" t-att-data-label="column.label">
                            <t t-esc="record[column.field] ?? '-'"/>
                        </td>
                        <td data-label="Műveletek">
                            <button 
                                class="btn btn-sm btn-info"
                                t-on-click="() => props.onSelectRecord(record.id)"
                            >
                                Részletek
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            
            <div t-else="" class="no-results">
                <p>Nincs találat.</p>
                <button class="btn btn-secondary" t-on-click="props.onGoBack">
                    Vissza a kereséshez
                </button>
            </div>

            <div class="pagination" t-if="props.totalPages > 1">
                <button
                    class="btn btn-sm btn-secondary"
                    t-att-disabled="props.currentPage === 1"
                    t-on-click="() => props.onGoToPage(props.currentPage - 1)"
                >
                    Előző
                </button>
                <span class="page-info">
                    Oldal <t t-esc="props.currentPage"/> / <t t-esc="props.totalPages"/>
                </span>
                <button
                    class="btn btn-sm btn-secondary"
                    t-att-disabled="props.currentPage === props.totalPages"
                    t-on-click="() => props.onGoToPage(props.currentPage + 1)"
                >
                    Következő
                </button>
            </div>
        </div>
    `;

    /**
     * Táblázat oszlopok meghatározása metadata alapján
     */
    getTableColumns() {
        // Alapértelmezett oszlopok ha nincs metadata vagy records
        const defaultColumns = [
            { field: 'decision_number', label: 'Határozatszám' },
            { field: 'subject', label: 'Tárgy' },
            { field: 'decision_date', label: 'Döntés Dátuma' },
            { field: 'type', label: 'Típus' }
        ];

        if (!this.props.records || this.props.records.length === 0) {
            return defaultColumns;
        }

        // Az első rekord típusa alapján határozzuk meg az oszlopokat
        const firstRecordType = this.props.records[0]?.type;

        if (!firstRecordType || !this.props.metadata?.types?.[firstRecordType]) {
            return defaultColumns;
        }

        // list_fields használata a metadata.types-ból
        const listFields = this.props.metadata.types[firstRecordType].list_fields;

        if (!listFields || listFields.length === 0) {
            return defaultColumns;
        }

        // Mezőnevek fordítása
        const fieldLabels = {
            'id': 'ID',
            'decision_number': 'Határozatszám',
            'subject': 'Tárgy',
            'mab_code': 'MAB kód',
            'institution': 'Benyújtó Intézmény',
            'votes': 'Szavazatok',
            'educational_level': 'Képzési szint',
            'decision': 'Döntés',
            'type': 'Típus',
            'decision_date': 'Döntés Dátuma'
        };

        return listFields.map(field => ({
            field: field,
            label: fieldLabels[field] || field
        }));
    }
}

export default RecordList;
